import Button from '@/components/shared/Button/Button';
import { formatTimeWithTimeZone } from '@/lib/utils/format-time-with-timezone';
import { Timeslot as ITimeslot } from '@addmile/backend-client';

interface TimeslotProps {
  slot: ITimeslot;
  handleDeleteTimeslot: (timeslotId: number) => void;
  isDeleting?: boolean;
  timezone: string;
}

const Timeslot = ({ slot, handleDeleteTimeslot, timezone }: TimeslotProps) => {
  return (
    <li
      key={slot.id}
      className="flex justify-between items-center px-3 rounded-lg shadow-s h:shadow-md bg-white"
    >
      <span>
        {formatTimeWithTimeZone(slot.fromTime, timezone).time} -{' '}
        {formatTimeWithTimeZone(slot.toTime, timezone).time}
      </span>
      <Button
        isIcon
        type="button"
        variant="transparent"
        className="w-8 h-8 border-none"
        onClick={() => handleDeleteTimeslot(slot.id)}
        prefixIcon={<img src={'/icons/close.svg'} />}
      />
    </li>
  );
};

export default Timeslot;
